import { Cloudinary } from '@cloudinary/url-gen'
import { CLOUDINARY_NAME } from 'constants/envs.ts'
import { Cloudinary as CloudinaryCore } from 'cloudinary-core'

// Cloudinary instance with our cloudinary name
export const cld = new Cloudinary({
  cloud: {
    cloudName: CLOUDINARY_NAME
  }
})

export const cld_core = new CloudinaryCore({ cloud_name: CLOUDINARY_NAME })

/**
 * Adds transformation parameters to Cloudinary URL to zoom on face
 * Only used for urls that are not managed by the Cloudinary SDK
 * @param {string} url
 * @returns {string}
 */
export const zoomOnFace = (url: string): string => {
  return url.replace('/upload/', '/upload/c_fill,g_face,ar_1:1/')
}
